document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.article-product-recommendations__slider-list');
  
  sliders.forEach(slider => {
    let isDown = false;
    let isDragged = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      isDragged = false;
      slider.style.cursor = 'grabbing';
      // Disable snapping and smooth scrolling during drag
      slider.style.scrollSnapType = 'none';
      slider.style.scrollBehavior = 'auto';
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('dragstart', (e) => {
      e.preventDefault(); // Prevent native image/link dragging
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.style.cursor = 'grab';
      // Re-enable snapping and smooth scroll
      slider.style.scrollSnapType = '';
      slider.style.scrollBehavior = '';
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.style.cursor = 'grab';
      // Re-enable snapping and smooth scroll
      slider.style.scrollSnapType = '';
      slider.style.scrollBehavior = '';
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; // Scroll speed multiplier
      
      if (Math.abs(walk) > 5) {
        isDragged = true;
      }
      
      slider.scrollLeft = scrollLeft - walk;
    });

    // Prevent clicking links if the user was dragging
    slider.querySelectorAll('a, button').forEach(link => {
      link.addEventListener('click', (e) => {
        if (isDragged) {
          e.preventDefault();
        }
      });
    });
  });
});
